module.exports = __webpack_public_path__ + "static/media/packet_loss.658fff21.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/packet_loss.mp4
// module id = 1489
// module chunks = 39